import React, { Component } from 'react';
import  {RedPageComponent} from './RedPageComponent.js';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'universal-cookie';
import {TgWidgetImplementationPage} from './TgWidgetImplementationPage';


class WidgetImplementationFromRoute extends React.Component {

    
    state = {
        text: ''
    }    

    constructor(props) {
        super(props);
        this.alias = this.props.match.params.alias
        
        //this.text =   '<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.0/jquery.min.js"></script><script>function onMessage(n){var e=n.data;"function"==typeof window[e.func]&&window[e.func].call(null,e.message)}function parentFunc(n){$("#ClientSaverWidget").remove()}window.addEventListener?window.addEventListener("message",onMessage,!1):window.attachEvent&&window.attachEvent("onmessage",onMessage,!1);$(document).ready(function(){if($(\'meta[name="viewport"]\').length>0){var i=\'<iframe id="ClientSaverWidget" onload="this.style.visibility=\\\'visible\\\'"; src=\\\'https://clientsaverwidgets.website.yandexcloud.net/widget_with_viewport_tg'+alias+'.html?v='+'\'+new Date().getMilliseconds()+\''+'\\\' style="visibility:hidden; position: fixed; z-index: 1000000000000000000; left: 0; top: 0; height: 100%; width: 100%;"></iframe>\';$("body").prepend(i)}else{i=\'<iframe  id="ClientSaverWidget" onload="this.style.visibility=\\\'visible\\\'"; src=\\\'https://clientsaverwidgets.website.yandexcloud.net/widget'+alias+'.html?v='+'\'+new Date().getMilliseconds()+\''+'\\\' style="visibility:hidden; position: fixed; z-index: 1000000000000000000; left: 0; top: 0; height: 100%; width: 100%;"></iframe>\';$("body").prepend(i)}});		</script>';        
    
    }

    componentWillMount() {
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetTgWidgetImplemenatation?alias='+this.alias, {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                    this.setState( {
                            text : res.data.text
                        });
                })
                .catch(err => {
                    console.log(err);
                    

                })
        
    }
   
    render() {
        return (
            <TgWidgetImplementationPage scriptsText={this.state.text} />
        )
        
        
    }
}

export default withRouter(WidgetImplementationFromRoute);